module.exports = __webpack_public_path__ + "img/icon-item-capsule.32ce2787.svg";